module.exports = __webpack_public_path__ + "6aa4b641be917104e210fdc8db0ec566.png";


//////////////////
// WEBPACK FOOTER
// ./app/stylesheets/tablet-preview/images/buttons.png
// module id = 1104
// module chunks = 4